import { render, staticRenderFns } from "./SubscribeForm.vue?vue&type=template&id=68a1b949"
import script from "./SubscribeForm.vue?vue&type=script&lang=js"
export * from "./SubscribeForm.vue?vue&type=script&lang=js"
import style0 from "./SubscribeForm.vue?vue&type=style&index=0&id=68a1b949&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports